<template>
  <div class="w-full">
      <div class="vx-row">
        <div class="vx-col md:w-1/2">
          <select-type-payment v-model="typePayment" :appendToBody="appendToBody" />
        </div>
        <div class="vx-col md:w-1/2">
          <select-account v-model="account" ref="account" :disabled="!typePayment" :filter="{typePayment: typePayment.id }" :appendToBody="appendToBody"/>
        </div>
      </div>
  </div>
</template>

<script>
// Store Module
import SelectTypePayment from './SelectTypePayment.vue'
import SelectAccount from '@/components/financial/account/SelectAccount.vue'

export default {
  components: {
    SelectTypePayment,
    SelectAccount
  },
  props: {
    value: {
      default () {
        return {
          typePayment: {},
          account: {}
        }
      }
    },
    disabled:{},
    appendToBody: {}
  },
  data () {
    return {

    }
  },
  computed: {
    typePayment: {
      get () {
        if (this.value && this.value.typePayment) return this.value.typePayment
        return {}
      },
      set (value) {
        this.$emit('input', {
          typePayment: value,
          account: null
        })
      }
    },
    account: {
      get () {
        if (this.value && this.value.account) return this.value.account
        return {}
      },
      set (value) {
        this.$emit('input', {
          typePayment: this.typePayment,
          account: value
        })
      }
    }
  },
  methods: {
    isValid () {
      this.$validator.validateAll()
      return !this.errors.has('typePayment')
    },
    onTypePaymentChange (typePayment) {
      this.$refs.account.filterByTypePayment(typePayment)
    }
  }
}
</script>
